import React from "react";

import classes from "./ErrorBoundary.module.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, errorInfo);
    console.log("Caught error");
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className={classes.container}>
          <p className={classes.errorText}>An Error has Occurred...</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
